import { defineComponent as _defineComponent } from 'vue'
import { useStore } from '~/store/composable';
import { computed, ref, useContext, watch } from '@nuxtjs/composition-api';


export default /*#__PURE__*/_defineComponent({
  __name: 'RewardSnackbar',
  setup(__props) {

const { state, dispatch } = useStore();

const show = ref(false);

const { $sanityImage } = useContext();

const showRewardSnackbar = computed(() => state?.rewards?.showRewardSnackbar);

const currentReward = computed(() => state?.rewards?.currentReward);

const rewardImage = computed(() => {
  if (!currentReward.value?.image) {
    return;
  }
  return $sanityImage.urlFor(currentReward.value.image).height(130).url();
});

watch(show, (current, previous) => {
  if (current === previous) {
    return;
  }
  dispatch('rewards/showRewardSnackbar', current);
});

watch(showRewardSnackbar, (current, previous) => {
  if (current === previous) {
    return;
  }
  show.value = current;
});

function openPrize() {
  dispatch('rewards/showRewardMysteryBoxModal', true);
  close();
}

function close() {
  show.value = false;
}

return { __sfc: true,state, dispatch, show, $sanityImage, showRewardSnackbar, currentReward, rewardImage, openPrize, close }
}

})